<template>
   <div class="flex h-100">
      <div v-if="loading" class="spinner-container">
         <BeatLoader color="#1389EF" />
      </div>

      <!-- MENU  -->
      <div class="menu" v-if="!loading">
         <!-- logo  -->
         <img src="/img/logo.png" alt="Logo BeePerf" class="logo" />

         <!-- menu sidebar  -->
         <div class="menu-wrapper">
            <div>
               <router-link :to="{ name: 'dashboard' }" class="menu-item">
                  <b-icon icon="view-dashboard" class="icone danger"></b-icon>
                  <div>Tableau de bord</div>
               </router-link>
            </div>
            <div>
               <router-link :to="{ name: 'statistiques' }" class="menu-item">
                  <b-icon icon="chart-areaspline" class="icone info"></b-icon>Statistiques
               </router-link>
            </div>
            <div>
               <router-link :to="{ name: 'ruches' }" class="menu-item">
                  <b-icon icon="archive" class="icone warning"></b-icon>Ruches
               </router-link>
            </div>
            <div>
               <router-link :to="{ name: 'visites' }" class="menu-item">
                  <b-icon icon="eye-check" class="icone success"></b-icon>Visites
               </router-link>
            </div>
         </div>
      </div>
      <!-- / menu sidebar -->

      <!-- partie droite de l'écran  -->
      <div class="partie-droite" v-if="!loading">
         <!-- NAVBAR  -->
         <Navbar />
         <!-- / navbar  -->
         <!-- DEBUT CONTENU  -->
         <div class="contenu">
            <fade-transition :duration="170" origin="center top" mode="out-in">
               <router-view></router-view>
            </fade-transition>
         </div>
         <!-- / content -->
      </div>
      <!-- / partie droite de l'écran  -->

      <!-- menu pour mobiles  *******-->
      <div class="menu-mobile" v-if="!loading">
         <router-link :to="{ name: 'dashboard' }">
            <div class="menu-mobile-item">
               <div>
                  <b-icon icon="view-dashboard" class="menu-mobile-icone"></b-icon>
               </div>
               <div>
                  Tableau
                  <br />de bord
               </div>
            </div>
         </router-link>
         <router-link :to="{ name: 'statistiques' }">
            <div class="menu-mobile-item">
               <div>
                  <b-icon icon="chart-areaspline" class="menu-mobile-icone"></b-icon>
               </div>
               <div>Statistiques</div>
            </div>
         </router-link>
         <router-link :to="{ name: 'ruches' }">
            <div class="menu-mobile-item">
               <div>
                  <b-icon icon="archive" class="menu-mobile-icone"></b-icon>
               </div>
               <div>Ruches</div>
            </div>
         </router-link>
         <router-link :to="{ name: 'visites' }">
            <div class="menu-mobile-item">
               <div>
                  <b-icon icon="eye-check" class="menu-mobile-icone"></b-icon>
               </div>
               <div>Visites</div>
            </div>
         </router-link>
      </div>
      <!-- /  menu pour mobiles **************  */ -->

      <!-- Footer  -->
      <Footer v-if="!loading" />
      <!-- / footer  -->
   </div>
</template>

<script>
   import Navbar from "@/components/nav/Navbar";
   import Footer from "@/components/nav/Footer";
   import { FadeTransition } from "vue2-transitions";
   import { BeatLoader } from "@saeris/vue-spinners";

   export default {
      name: "DashboardLayout",
      components: {
         BeatLoader,
         Footer,
         FadeTransition,
         Navbar
      },
      data() {
         return {
            loading: true
         };
      },
      mounted() {
         this.getUser();

         // installer app
         let installPrompt;
         window.addEventListener("beforeinstallprompt", e => {
            e.preventDefault();
            installPrompt = e;
            this.installBtn = true;
         });

         this.installer = () => {
            this.installBtn = false;
            installPrompt.prompt();
            installPrompt.userChoice.then(result => {
               if (result.outcome === "accepted") {
                  console.log("user accepted");
               } else {
                  console.log("user denied");
               }
               installPrompt = null;
            });
         };
      },
      computed: {
         user() {
            return this.$store.state.user;
         }
      },
      methods: {
         async getUser() {
            this.loading = true;
            await this.$store.dispatch("getUser");
            console.log(this.user);

            // si past due !!
            if (
               this.user.abonnement &&
               this.user.abonnement.stripe_status == "past_due"
            ) {
               this.$router.push({
                  name: "logout",
                  params: {
                     message:
                        "Votre dernier prélèvement automatique a échoué, un email vient de vous être envoyé pour réguler votre situation et récupérer votre accès."
                  }
               });
            }

            // si l'utilisateur a plus de 10 ruches, check son abo
            if (this.user.ruches > 10) {
               if (
                  this.user.abonnement &&
                  this.user.abonnement.stripe_status == "active"
               ) {
                  this.loading = false;
               } else if (
                  (this.user.abonnement &&
                     this.user.abonnement.stripe_status == "canceled") ||
                  !this.user.abonnement
               ) {
                  this.$router.push({ name: "tropDeRuches" });
               }
            } else {
               this.loading = false;
            }
         }
      }
   };
</script>
